import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'deposit-component',
  templateUrl: '../sharedTemplates/cashback.component.html',
})
export class CashBackComponent implements OnInit {
  depositList = [];
  cashbackBalance;
  date;
  hasNoCashback = false;
  result;

  constructor(private _ApiService: ApiService, private _UiHelper: UiHelper, public _UserHelper: UserHelper, private _LocalizationService: LocalizationService) {
    this.getStatus();
  }

  ngOnInit() {
    this._UiHelper.setNavbarTitle('CASHBACK', false);
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();
  }

  getStatus() {
    this._ApiService.getCasbackStatus().then(res => {
      if (res && res.result && res.result < 0) {
        this.result = res.result;
        this.hasNoCashback = false;
      } else if (res && res.result && res.result > 0) {
        this.result = res.result;
        this.getCashbackBalance();
        this.hasNoCashback = true;
      }
    });
  }

  joinCashback() {
    this._ApiService.joinCashback().then(res => {
      this.getStatus();
    });
  }

  getCashbackBalance() {
    this._ApiService.getCashbackBalance().then((res: any) => {
      //console.log('--getCashbackBalance--',res);

      if (res && res.length > 0 && res[0].CashBackBalance) {
        this.cashbackBalance = res[0].CashBackBalance;
        this.date = res[0].ActiveDate;
      }
    });
  }
}
